export const USER_REFRESH = "USER_REFRESH";
export const USER_LOAD = "USER_LOAD";
export const USER_LOADED = "USER_LOADED";
export const USER_FAILED = "USER_FAILED";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const FETCH_PROFILE = "USER:FETCH_PROFILE";
export const FETCH_PROFILE_LOADING = "USER:FECTH_PROFILE_LOADING";
export const FETCH_PROFILE_FAILED = "USER:FECTH_PROFILE_FAILED";
export const FETCH_FISCAL_PROFILE = "USER:FETCH_FISCAL_PROFILE";
export const FETCH_FISCAL_PROFILE_LOADING = "USER:FECTH_FISCAL_PROFILE_LOADING";
export const FETCH_FISCAL_PROFILE_FAILED = "USER:FECTH_FISCAL_PROFILE_FAILED";
export const UPDATE_DELETION_REASON = "USER:UPDATE_DELETION_REASON";
export const DELETE_USER = "USER:DELETE_USER";
export const OPEN_DELETE_MODAL = "USER:OPEN_DELETE_MODAL";
export const CLOSE_DELETE_MODAL = "USER:CLOSE_DELETE_MODAL";
export const UPDATE_CERTIFICATIONS = "USER:UPDATE_CERTIFICATION";
export const GET_CUSTOM_USER_FIELDS = "USER:GET_CUSTOM_USER_FIELDS";
